
import Swiper, { Autoplay, Pagination, Navigation } from 'swiper';

import 'swiper/swiper-bundle.css';
Swiper.use([Pagination, Autoplay, Navigation]);

export default {
    props: {
        settings: {
            type: Object,
            default: () => ({
                slidesPerView: 'auto',
            }),
        },
        type: { type: String, required: false }
    },
    data: () => ({
        mySwiper: null,
    }),
    mounted() {
        this.mySwiper = new Swiper(this.$refs.swiper, this.settings);
    },
    beforeDestroy() {
        setTimeout(() => {
            this.mySwiper.destroy();
        }, 200);
    },
};
